import { render } from "./dang-nhap-old.vue?vue&type=template&id=e58095ec&scoped=true"
import script from "./dang-nhap-old.vue?vue&type=script&lang=js"
export * from "./dang-nhap-old.vue?vue&type=script&lang=js"

import "./dang-nhap-old.vue?vue&type=style&index=0&id=e58095ec&scoped=true&lang=css"
import "./dang-nhap-old.vue?vue&type=style&index=1&id=e58095ec&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e58095ec"]])

export default __exports__